module.exports = __webpack_public_path__ + "img/schumacher.56198172.jpg";